import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/app/[locale]/contul-meu/recuperare-parola/PageForm.tsx");
